import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "./ui/button";
import { tx } from "../lib/tx";

export const COMPANY = {
  name: "Love Connect +",
  siren: "837746700",
  email: "contactloveconnect@gmail.com",
};

export function LegalLayout({ title, children, testId }) {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background text-white" data-testid={testId}>
      <header className="sticky top-0 z-50 bg-background/95 backdrop-blur border-b border-white/5 px-4 py-4" style={{ paddingTop: "max(1rem, env(safe-area-inset-top))" }}>
        <div className="flex items-center gap-3 max-w-2xl mx-auto">
          <Button variant="ghost" size="icon" onClick={() => navigate(-1)} className="text-white" data-testid="legal-back-btn">
            <ArrowLeft className="w-6 h-6" />
          </Button>
          <h1 className="font-heading text-xl font-semibold">{title}</h1>
        </div>
      </header>
      <div className="max-w-2xl mx-auto px-4 py-8 space-y-6 text-sm leading-relaxed text-muted-foreground">
        {children}
        <section className="pt-4 border-t border-white/10" data-testid="legal-company-info">
          <p className="text-white font-semibold">{COMPANY.name}</p>
          <p>{tx("N° d'immatriculation :")} {COMPANY.siren}</p>
          <p>{tx("Contact :")} <a href={`mailto:${COMPANY.email}`} className="text-primary">{COMPANY.email}</a></p>
        </section>
      </div>
    </div>
  );
}

export function LegalSection({ title, children }) {
  return (
    <section className="space-y-2">
      <h2 className="text-base font-semibold text-white">{title}</h2>
      {children}
    </section>
  );
}
